import { createFileRoute } from "@tanstack/react-router";
import { SiteShell, PageHero } from "@/components/site/SiteShell";
import { Section, SectionHeader, CTABand } from "@/components/site/Blocks";
import { states } from "@/data/states";
import { buildHead } from "@/lib/seo-head";

export const Route = createFileRoute("/es/donde-prestamos")({
  head: () =>
    buildHead({
      title: "Dónde Prestamos — Estados para Préstamos DSCR | Simply Approved",
      description:
        "Cobertura de préstamos DSCR y con fines comerciales por estado. Con licencia en Florida y Colorado; préstamos comerciales para inversionistas en 37 estados + DC.",
      url: "/es/donde-prestamos",
      locale: "es",
      keywords: "dónde prestan préstamos DSCR, estados préstamos DSCR, préstamos DSCR Florida, préstamos DSCR Colorado, préstamos inversión por estado",
      breadcrumbs: [
        { name: "Inicio", url: "/es" },
        { name: "Dónde prestamos", url: "/es/donde-prestamos" },
      ],
      service: { name: "Cobertura de préstamos DSCR y con fines comerciales" },
    }),
  component: WhereWeLend,
});

function WhereWeLend() {
  return (
    <SiteShell>
      <PageHero eyebrow="Dónde prestamos" title="Cobertura de préstamos DSCR y con fines comerciales." subtitle="Con licencia en Florida y Colorado para préstamos residenciales a consumidores. Préstamos con fines comerciales para inversionistas en nuestra área de servicio aprobada." />
      <Section>
        <SectionHeader title="Área de servicio" center />
        <div className="mt-8 grid gap-3 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
          {states.map((s) => (
            <span
              key={s.slug}
              className="rounded-xl border border-border bg-card px-4 py-3 text-sm font-semibold text-foreground"
            >
              {s.name}
            </span>
          ))}
        </div>
        <p className="mt-6 text-sm text-muted-foreground">
          La disponibilidad de producto específico varía por estado, tipo de propiedad y programa.
          Contáctenos para confirmar qué programas están disponibles en su ubicación.
        </p>
      </Section>
      <CTABand title="¿Tiene una propiedad en mente?" body="Envíenos su escenario y confirmaremos disponibilidad de programa." />
    </SiteShell>
  );
}
